import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import DatadogService from '@src/shared/services/datadog';
import Scoober from './Scoober';
import { isInUrl } from './shared/utils';
import 'snacks-design-system/lib/css-modules/main.module.scss';
import 'snacks-design-system/lib/css-modules/theme.module.scss';
import JetCourier from './JetCourier';

/* if (process.env.NODE_ENV === 'development') {
    const { worker } = require('./mocks/browser')
    worker.start();
    (window as any).stopMockingJay = worker.stopHandler;
  } */

DatadogService.init();

const renderApp = () => {
  if (isInUrl('apps/jetcourier')) return <JetCourier />;
  if (isInUrl('apps')) return <Scoober />;
  return <App />;
};

ReactDOM.render(renderApp(), document.getElementById('root'));
